import React from 'react';
import { NavActions } from './NavActions';
interface Tab {
  label: string;
  href: string;
  active?: boolean;
}
export interface NavBarProps {
  tabs: Tab[];
  title?: string;
  'data-id'?: string;
}
export function NavBar({
  tabs,
  title = 'Dashboard',
  'data-id': dataId
}: NavBarProps) {
  return <nav className="
        w-full h-16 bg-white border-b border-[#CBD5E1]
        px-6 flex items-center gap-4
      " data-id="element-1867">



      <h1 className="text-lg font-semibold text-[#0F172A] m-0" data-id="element-1868">{title}</h1>

      <div aria-hidden="true" className="flex-1" data-id="element-1869"></div>

      <NavActions data-id="element-1870" />
    </nav>;
}